const SEAT_CHOICE_TYPES = {
  SEAT_CHOICE: 'SeatChoice',
  SEAT_CHOICE_UPSELL: 'SeatChoiceUpsell',
  SEAT_CHOICE_WAIVED_UPGRADE: 'SeatChoiceWaivedUpgrade',
  SEAT_CHOICE_FARE_UPGRADE: 'SeatChoiceFareUpgrade',
  SEAT_CHOICE_DELTA: 'SeatChoiceDL',
};

export default SEAT_CHOICE_TYPES;
